import { apiSlice } from "./apiSlice";

export const pressReleaseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPressRelease: builder.mutation({
      query: (pressReleaseData) => ({
        url: "/pressReleases/createPressRelease",
        method: "POST",
        body: pressReleaseData,
      }),
      invalidatesTags: ["PressRelease"],
    }),

    deletePressRelease: builder.mutation({
      query: (id) => ({
        url: `/pressReleases/deletePressRelease/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PressRelease"],
    }),

    updatePressRelease: builder.mutation({
      query: ({ pressReleaseData, id }) => ({
        url: `/pressReleases/updatePressRelease/${id}`,
        method: "PATCH",
        body: pressReleaseData,
      }),
      invalidatesTags: ["PressRelease"],
    }),

    getAllPressReleases: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/pressReleases/getAllPressReleases?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["PressRelease"],
    }),
    getPressReleaseById: builder.query({
      query: (id) => ({
        url: `/pressReleases/getPressReleaseById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreatePressReleaseMutation,
  useUpdatePressReleaseMutation,
  useDeletePressReleaseMutation,
  useGetAllPressReleasesQuery,
  useGetPressReleaseByIdQuery,
} = pressReleaseApi;
